<template>
  <LeftTeaser :title="title" :subtitles="subtitles" :benefits="benefits" />
</template>

<script>
import LeftTeaser from '@/components/auth/left/LeftTeaser.vue'
import { $t } from '@/composables/translation'

export default {
  name: 'LeftRegisterRecruiter',
  components: {
    LeftTeaser,
  },
  setup() {
    return {
      title: $t('Manage your flexible workforce'),
      subtitles: [],
      benefits: [],
    }
  },
}
</script>
